import { App } from './core/App';

// 全局 App 实例
export let appInstance: App | null = null;

// 检测 WebGL2 支持
function checkWebGL2Support(): boolean {
  const canvas = document.createElement('canvas');
  const gl = canvas.getContext('webgl2');
  return gl !== null;
}

// 主入口
async function main() {
  console.log('🌐 CodeVerse 3D 启动中...');
  
  // 检测 WebGL2
  const webgl2Supported = checkWebGL2Support();
  
  if (!webgl2Supported) {
    alert('您的浏览器不支持 WebGL2，请使用最新版 Chrome/Firefox/Edge 浏览器。');
    return;
  }
  
  // 初始化应用
  const app = new App();
  appInstance = app; // 保存全局引用
  await app.initialize();
  
  // 启动渲染循环
  app.run();
  
  console.log('✅ CodeVerse 3D 启动完成!');
}

// DOM 加载完成后启动
document.addEventListener('DOMContentLoaded', main);
